import Commons from './Commons';

export { default as WhatsApp } from './WhatsApp';

export default Commons;
